import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#03224C] text-white p-4 text-center">
      <p>&copy; 2025 Reich Bella. Tous droits réservés.</p>
    </footer>
  );
};

export default Footer;
